import React from "react";

// AdGen Store brand mark — cyan mandala on navy.
// Uses the PNG at /public/adgen-logo-v2.png so we honour the exact art the client provided.
// Wordmark next to it is kept in Manrope 800 with the "Store" segment in cyan.
export const Logo = ({ size = 32, showWordmark = true, className = "" }) => (
  <span className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <img
      src="/adgen-logo-v2.png"
      alt="AdGen Store"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="rounded-md object-contain"
      draggable={false}
    />
    {showWordmark && (
      <span className="text-xl font-extrabold tracking-tight">
        AdGen<span className="text-primary">Store</span>
      </span>
    )}
  </span>
);
